import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";

/**
 * Hook for querying organizations by user ID
 */
export function useUserOrgs(userId: string) {
  return useQuery({
    queryKey: ["listOrgsByUser", userId],
    queryFn: async () => api.listOrgsByUser({ user_id: userId }),
    enabled: !!userId,
  });
}
